<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/TD1T9Z/tc-custom/9781646562541.jpg?1723404720512" alt="This image is the cover for the book Rory's Rock"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Rory's Rock
      </h1>
      <p class="bookDescription body article font2">
        <p>Rory Brown grew up in care but found a home, friendship, and a much-needed sense of security working on the Double J ranch. As far as Rory is concerned, fellow cowboy, Zane Fox, is perfect. Zane is strong but gentle, kind, big, ruggedly handsome ... and straight.<br/><br/>Rory works alongside Zane, eats alongside Zane, and when an ice storm causes a power outage, he sleeps alongside Zane ... for warmth.<br/><br/>Inhibitions lowered after getting drunk on his twenty-first birthday, Rory Kisses Zane and confesses his feelings for the man. The next day, when Rory learns his father is dying, although estranged from the man, Rory feels obligated to see him one last time. Zane follows Rory to Kansas and confesses he has feelings for Rory, too. After learning his father has died, Rory and Zane set off for home in Zane's old truck. However, bad weather and a mechanical breakdown mean they have to hole up in a guesthouse. Rory doesn't mind, it gives him a chance to explore things with his hunky new boyfriend. And there's a lot of Zane to explore.<br/><br/>Life on the ranch is little short of idyllic, Zane is everything and more Rory could want in a lover, protector, and friend. A tiny part of Rory knows he should brace himself for if/when the other shoe -- or cowboy boot -- drops. Rory is thrown when evidence of Zane's heterosexual past reveals itself, leaving him totally devastated.<br/><br/>Are Zane's feet made of clay, or can he redeem himself and once again become Rory's rock?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Drew Hunt
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?945fb264